import { render, staticRenderFns } from "./metopeOrder.vue?vue&type=template&id=3b2762e8&scoped=true&"
import script from "./metopeOrder.vue?vue&type=script&lang=js&"
export * from "./metopeOrder.vue?vue&type=script&lang=js&"
import style0 from "./metopeOrder.vue?vue&type=style&index=0&id=3b2762e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2762e8",
  null
  
)

export default component.exports